import $ from 'jquery';


//import jQueryResizeDom from "jquery-resizable-dom";
require("jquery-ui/ui/widgets/resizable");
require("jquery-ui/ui/widgets/tabs");
require("jquery-ui/ui/widgets/dialog");
require("/static/src/js/jquery.dragscroll");

require("jquery-ui/themes/base/images/ui-bg_flat_0_aaaaaa_40x100.png");
require("jquery-ui/themes/base/images/ui-icons_444444_256x240.png");
require("jquery-ui/themes/base/images/ui-icons_555555_256x240.png");
require("jquery-ui/themes/base/images/ui-icons_777620_256x240.png");
require("jquery-ui/themes/base/images/ui-icons_777777_256x240.png");
require("jquery-ui/themes/base/images/ui-icons_cc0000_256x240.png");
require("jquery-ui/themes/base/images/ui-icons_ffffff_256x240.png");




import "/static/src/js/jquery.panFullSize";

import showAreaChart from "/static/src/js/AreaChart";
import {loadCurrentSlide,loadPreviousSlide,loadNextSlide,insertTextPageHis} from "/static/src/js/textPage";
import {updateIsMustReviewFlg} from "/static/src/js/star-button";
import ace from "brace";
import "brace/theme/eclipse";
import "brace/mode/pgsql";
import "brace/mode/java";
import "brace/ext/language_tools";


window.showAreaChart = showAreaChart;
window.loadCurrentSlide = loadCurrentSlide;
window.loadPreviousSlide = loadPreviousSlide;
window.loadNextSlide = loadNextSlide;

window.insertTextPageHis = insertTextPageHis;
window.updateIsMustReviewFlg = updateIsMustReviewFlg;